export default "__VITE_ASSET__soVV37rJ__"